<template>
  <div class="product-card-grid-item">
    <Combo v-if="catalogElement.element.entity ==='Combo'" :catalogElement="catalogElement"></Combo>
    <ProductCardSmall v-else :catalogElement="catalogElement"></ProductCardSmall>
  </div>
</template>

<script>
import ProductCardSmall from "./ProductCardSmall.vue";
import Combo from "@/components/combos/Combo.vue";

export default {
  name: "CatalogElement",
  components: {
    Combo,
    ProductCardSmall,
  },
  data: function () {
    return {}
  },
  props: {
    catalogElement: {},
  },
  computed:{},
  methods: {},
  mounted() {},
  mixins: []
}
</script>

<style scoped>

</style>
